import React, { useCallback, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TableTemplate from "./TableTemplate";
import { useClient } from "../../utilities/ClientProvider";
import keycloak from "../../Keycloak";
import {getJobsByCompanyId, getSelectedJobsByCompanyId} from "../../utilities/HrAPI";

const JobsList = () => {
    const [jobs, setJobs] = useState([]);
    const { client } = useClient(); // Get client from context

    const columns = [
        { id: "jobTitle", label: "Job title", minWidth: 150 },
        { id: "status", label: "Status", minWidth: 150 },
        { id: "dateModified", label: "Date modified", minWidth: 150 },
        { id: "action", label: "Action", minWidth: 150 }
    ];

    const fetchJobs = useCallback(async () => {
        if (keycloak && keycloak.token) {
            try {
                if (client === 'all') {
                    const allJobs = await getJobsByCompanyId(keycloak.token);
                    setJobs(allJobs);
                } else {
                    const selectedJobs = await getSelectedJobsByCompanyId(client, keycloak.token);
                    setJobs(selectedJobs);
                }
            } catch (e) {
                console.error('Error fetching jobs:', e);
                setJobs([]);
            }
        }
    }, [client]);

    useEffect(() => {
        fetchJobs();
    }, [fetchJobs, client]);

    return (
        <div data-testid="jobsListContainer" style={{ padding: "20px 5%" }}>
            <div className="row" data-testid="jobsListGrid">
                <Grid item xs={6} data-testid="jobsListHeading">
                    <h1 style={{ marginBottom: "15px" }}>Job Positions</h1>
                </Grid>

                <Grid item xs={6}>
                    <Button
                        href="JobsAdd"
                        style={{
                            float: "right",
                            backgroundColor: '#FF6600',
                            width: '89px',
                            height: '40px',
                            fontFamily: 'Poppins',
                            color: '#FFFFFF',
                        }}
                    >
                        Add
                    </Button>
                </Grid>

                <Grid item xs={12}>
                    <TableTemplate data={jobs} columns={columns} clientId={client}/>
                </Grid>
            </div>
        </div>
    );
};

export default JobsList;